import React from 'react';
import { Center, Flex, Image, Text } from '@chakra-ui/core';

export interface EmptyQuestionsViewProps {
  message: string;
  imageSrc?: string;
}

export const EmptyQuestionsView: React.FC<EmptyQuestionsViewProps> = ({ message, imageSrc = '/questions.svg' }) => (
  <Center>
    <Flex direction="column" data-testid="NoQuestions" align="center" p={3} textAlign="center">
      <Image src={imageSrc} w="180px" h="auto" alt={message} />
      <Text mt="8">
        <b>{message}</b>
      </Text>
    </Flex>
  </Center>
);
